exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2VuHt{margin:0 auto;max-width:1000px}.QOUG7{max-width:680px}._2mlTn{font-size:1.875em;margin:0;font-weight:500;line-height:1.2}._2mlTn+._286lo{margin-top:16px;margin-top:1rem}@media screen and (min-width:768px){._2mlTn{font-size:3em;line-height:54px}}._286lo{font-size:1.125em;margin:0;color:#9b9b9b;line-height:1.5}._286lo+.rCsmc{margin-top:16px;margin-top:1rem}@media screen and (min-width:768px){._286lo{font-size:1.5em;line-height:34px}}.rCsmc{margin-top:16px;margin-top:1rem}@media screen and (min-width:768px){.rCsmc{margin-top:2rem}}", ""]);

// exports
exports.locals = {
	"root": "_2VuHt",
	"container": "QOUG7",
	"title": "_2mlTn",
	"lead": "_286lo",
	"content": "rCsmc"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":{"discardComments":{"removeAll":true}}}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./src/components/Page/Page.css
// module id = 682
// module chunks = 1 3